import { isVaultNotActive } from '../../../keystore/services/keystore-error';
import { OrganisationConnectorService, ConnectorAssignment } from 'src/app/con-x/saas-service-management/organisation-connector.service';
import { ConnectorLinkDialogComponent } from 'src/app/con-x/saas-service-management/connector-link-dialog.component';
import { Router } from '@angular/router';
import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MatStepper } from '@angular/material/stepper';
import { MatDialog } from '@angular/material/dialog';
import { EMPTY, firstValueFrom, Observable, Subject, timer } from 'rxjs';
import { catchError, exhaustMap, takeUntil } from 'rxjs/operators';
import { DIDEntry } from '../../../did-manager/models/did-entry.model';
import { DidEntryMgmtService } from '../../../did-manager/services/did-entry-mgmt.service';
import { KeystoreApiService } from '../../../keystore/services/keystore-api.service';
import { KeystoreAccessService } from '../../../keystore/services/keystore-access.service';
import { KeyPairMetadata } from '../../../keystore/models/keystore-api.models';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { CanComponentDeactivate } from 'src/app/services/auth-guard-service/authGuardService';
import { FederatorOnboardingService, MembershipStatus, OnboardingRequirements } from '../../services/federator-onboarding.service';
import { OnboardingIdentityDialogComponent } from '../onboarding-identity-dialog/onboarding-identity-dialog.component';
import { SidemenuServiceService } from 'src/app/services/componentServices/sidemenu-service/sidemenu-service.service';

@Component({ selector: 'app-data-space-registration', standalone: false, templateUrl: './data-space-registration.component.html', styleUrls: ['./data-space-registration.component.scss'] })
export class DataSpaceRegistrationComponent implements OnInit, OnDestroy, CanComponentDeactivate {
  @ViewChild('stepper') stepper!: MatStepper;
  dataSpaceForm: FormGroup = this.fb.group({ did: ['', Validators.required], keyPairId: ['', Validators.required], self_description: this.fb.group({}), terms: this.fb.array([]) });
  dids: DIDEntry[] = [];
  keys: KeyPairMetadata[] = [];
  ownerId = 0;
  requirements: OnboardingRequirements | null = null;
  membership: MembershipStatus | null = null;
  connector: ConnectorAssignment | null = null;
  connectorBusy = false;
  isSubmitting = false;
  loading = true;
  error = '';
  vaultSetupRequired = false;
  vaultProvisioning = false;
  get vaultNotActive(): boolean { return this.vaultSetupRequired; }
  get canProvisionVault(): boolean { return this.keystoreAccess.hasAdminRole(this.ownerId); }
  submissionStatus = '';
  private destroyed = new Subject<void>();
  private stopPolling = new Subject<void>();
  private connectorPollingStarted = false;
  private viewDestroyed = false;
  private readonly importedKeys = new Map<string,string>();
  constructor(private connectors: OrganisationConnectorService, private router: Router, private cdr: ChangeDetectorRef, private fb: FormBuilder, private route: ActivatedRoute, private entries: DidEntryMgmtService,
    private keysApi: KeystoreApiService, private keystoreAccess: KeystoreAccessService, private organisations: OrganisationService, private federator: FederatorOnboardingService, private dialog: MatDialog,
    private sidemenu: SidemenuServiceService, private zone: NgZone) {}
  ngOnInit() {
    this.route.parent!.params.pipe(takeUntil(this.destroyed)).subscribe(params => {this.ownerId=Number(params['organisationId']);void this.load();});
  }
  async load() {
    this.loading=true;this.error='';this.vaultSetupRequired=false;
    try {
      if(!this.ownerId)throw new Error('Organisation konnte nicht ermittelt werden.');
      await this.organisations.setActiveOrganisation(this.ownerId);
      if (this.viewDestroyed) return;
      this.requirements=await firstValueFrom(this.federator.requirements());
      if (this.viewDestroyed) return;
      this.dataSpaceForm.setControl('terms',this.fb.array(this.requirements.terms.map(()=>this.fb.control(false,Validators.requiredTrue))));
      await this.loadDids();
      if (this.viewDestroyed) return;
      this.membership=await firstValueFrom(this.federator.status(this.ownerId));
      this.sidemenu.updateConstructXOnboardingStatus(this.ownerId, this.membership?.status === 'accepted');
      this.connector=await firstValueFrom(this.connectors.get(this.ownerId));
      this.poll();
    }catch(error:any){
      this.vaultSetupRequired=isVaultNotActive(error);
      this.error=this.vaultSetupRequired ? '' : error.error?.detail || error.error?.message || error.message || 'Onboarding konnte nicht geladen werden.';
    }
    finally{this.loading=false;if (!this.viewDestroyed) this.cdr.markForCheck();}
  }
  async loadDids() {
    const [dids,keys]=await Promise.all([firstValueFrom(this.entries.getUserDIDs(this.ownerId,true,-1,-1)),firstValueFrom(this.keysApi.listKeyPairs(this.ownerId))]);
    if (this.viewDestroyed) return;
    this.dids=dids.content;this.keys=keys.items;this.cdr.markForCheck();
  }
  onDidSelect(did: DIDEntry) {
    this.dataSpaceForm.controls.did.setValue(did.did);
    const id=this.importedKeys.get(did.did) || this.keys.find(key => did.keySuffix === '#key-'+key.id)?.id || '';
    this.dataSpaceForm.controls.keyPairId.setValue(id);this.dataSpaceForm.markAsDirty();
  }
  get selectedKey() { return this.keys.find(key => key.id === this.dataSpaceForm.controls.keyPairId.value) || null; }
  async provisionVault() {
    if(!this.canProvisionVault || this.vaultProvisioning)return;
    this.vaultProvisioning=true;this.error='';
    try { await firstValueFrom(this.keysApi.provisionNamespace(this.ownerId)); await this.load(); }
    catch(error:any) { this.vaultSetupRequired=true;this.error=error.error?.message || 'Der Vault konnte nicht eingerichtet werden.'; }
    finally { this.vaultProvisioning=false;this.cdr.markForCheck(); }
  }
  openIdentity(mode: 'create'|'import') {
    this.dialog.open(OnboardingIdentityDialogComponent,{width:'780px',maxWidth:'96vw',data:{organisationId:this.ownerId,mode}}).afterClosed().subscribe(async result=>{
      if(!result)return;this.importedKeys.set(result.entry.did,result.keyPairId);
      try{await this.loadDids();this.onDidSelect(result.entry);}catch{this.error='Die Identitätsliste konnte nicht aktualisiert werden.';}
    });
  }
  onSdReady(form: FormGroup) { this.dataSpaceForm.setControl('self_description',form); }
  get sd() {return this.dataSpaceForm.controls.self_description as FormGroup;}
  get terms() {return this.dataSpaceForm.controls.terms as FormArray;}
  get identityValid() {return this.dataSpaceForm.controls.did.valid && this.dataSpaceForm.controls.keyPairId.valid;}
  get selectedDid() {return this.dids.find(did=>did.did===this.dataSpaceForm.controls.did.value);}
  get storageKey() {return 'construct-x-onboarding-'+this.ownerId;}
  get statusLabel() {return this.membership?({submitting:'Übertragung ausstehend',received:'Anfrage eingegangen',under_review:'Anfrage wird geprüft',accepted:'Teilnahme bestätigt',rejected:'Anfrage abgelehnt'})[this.membership.status]:'';}
  editingControl: AbstractControl | null = null;
  get reviewFields(): {label:string,value:string,control:AbstractControl}[] {
    const result: {label:string,value:string,control:AbstractControl}[]=[];
    const labels: Record<string,string>={name:'Organisationsname',headquartersAddress:'Geschäftsadresse',legalAddress:'Juristische Anschrift',registrationNumber:'Identifikationsnummer','street-address':'Straße und Hausnummer','postal-code':'Postleitzahl',locality:'Stadt',countryCode:'Ländercode',countryName:'Land',region:'Region',description:'Beschreibung',vatID:'Umsatzsteuer-Nr.',leiCode:'LEI'};
    const walk=(control:AbstractControl,prefix='')=>{
      if(control instanceof FormGroup || control instanceof FormArray) {
        for(const [key,child] of Object.entries(control.controls)) {
          const part=key.split(/[#/]/).pop()!;
          walk(child, control instanceof FormArray ? prefix : (child instanceof FormGroup || child instanceof FormArray ? (labels[part] || part)+' · ' : prefix+(labels[part] || part)));
        }
      } else if(control.value || this.editingControl === control) result.push({label:prefix,value:String(control.value),control});
    };
    walk(this.sd);return result;
  }

  async submit() {
    this.dataSpaceForm.markAllAsTouched();if(this.dataSpaceForm.invalid || !this.requirements || this.isSubmitting)return;
    this.isSubmitting=true;this.error='';this.submissionStatus='Anfrage digital unterschreiben …';
    try {
      const raw=this.dataSpaceForm.getRawValue();const suffix=this.selectedDid?.keySuffix;
      if(!suffix)throw new Error('Die ausgewählte DID hat keinen Signaturschlüssel.');
      const signed=await firstValueFrom(this.federator.sign(this.ownerId,raw.keyPairId!,{
        did:raw.did,verificationMethodId:raw.did+suffix,audience:this.requirements.audience,selfDescription:raw.self_description,
        terms:this.requirements.terms.map(({id,url,sha256})=>({id,url,sha256}))
      }));
      this.submissionStatus='Beitrittsanfrage senden …';
      this.membership=await firstValueFrom(this.federator.submit(this.ownerId,signed.presentation));
      this.dataSpaceForm.markAsPristine();this.poll();
    }catch(error:any){
      this.vaultSetupRequired=isVaultNotActive(error);
      this.error=this.vaultSetupRequired ? '' : error.error?.detail || error.error?.message || error.message || 'Die Beitrittsanfrage konnte nicht gesendet werden.';
    }
    finally{this.isSubmitting=false;this.submissionStatus='';this.cdr.markForCheck();}
  }
  poll() {
    if (this.viewDestroyed) return;
    if (!this.connectorPollingStarted) {
      this.connectorPollingStarted = true;
      this.pollingTimer(10000).pipe(
        takeUntil(this.destroyed),
        exhaustMap(() => this.connectors.get(this.ownerId).pipe(catchError(() => EMPTY)))
      ).subscribe(assignment => {
        this.connector = assignment;
        this.cdr.markForCheck();
      });
    }
    this.stopPolling.next();if(!this.membership || this.membership.status==='rejected' || (this.membership.status==='accepted' && this.membership.credentialStatus==='STORED'))return;
    this.pollingTimer(5000).pipe(takeUntil(this.destroyed),takeUntil(this.stopPolling),exhaustMap(()=>this.federator.status(this.ownerId).pipe(catchError(()=>{this.error='Status konnte nicht aktualisiert werden. Ein neuer Versuch erfolgt automatisch.';this.cdr.markForCheck();return EMPTY;})))).subscribe({
      next: status=>{this.membership=status;this.sidemenu.updateConstructXOnboardingStatus(this.ownerId, status?.status === 'accepted');this.cdr.markForCheck();if(status && (status.status==='rejected' || (status.status==='accepted' && status.credentialStatus==='STORED')))this.stopPolling.next();},
      error:()=>{this.error='Status konnte nicht aktualisiert werden. Bitte erneut laden.';this.cdr.markForCheck();}
    });
  }
  private pollingTimer(interval: number): Observable<number> {
    return new Observable(subscriber => this.zone.runOutsideAngular(() => {
      const polling = timer(interval, interval).subscribe(value => this.zone.run(() => subscriber.next(value)));
      return () => polling.unsubscribe();
    }));
  }
  async retrySubmission() {
    if(this.isSubmitting)return;
    this.isSubmitting=true;this.error='';
    try { this.membership=await firstValueFrom(this.federator.retry(this.ownerId));this.poll(); }
    catch(error:any){this.error=error.error?.message || 'Die Übertragung konnte nicht wiederholt werden.';}
    finally{this.isSubmitting=false;this.cdr.markForCheck();}
  }
  signAgain() {if(this.membership?.status!=='submitting' || this.isSubmitting)return;this.stopPolling.next();this.error='';this.membership=null;this.dataSpaceForm.markAsDirty();this.cdr.markForCheck();}
  retry() {if(this.membership?.status!=='rejected')return;this.membership=null;}
  async requestConnector(kind: 'DEPLOY'|'EXTERNAL', connectorUrl?: string) {
    if(this.connectorBusy)return;
    if(kind==='EXTERNAL' && !connectorUrl){
      this.dialog.open(ConnectorLinkDialogComponent,{width:'620px',maxWidth:'96vw',data:{mode:'external'}}).afterClosed().subscribe(result=>{if(result)void this.requestConnector('EXTERNAL',result.connectorUrl);});return;
    }
    this.connectorBusy=true;this.error='';
    try{this.connector=await firstValueFrom(this.connectors.request(this.ownerId,kind,connectorUrl));}
    catch(error:any){this.error=error.error?.message || 'Die Connector-Anfrage konnte nicht gesendet werden.';}
    finally{this.connectorBusy=false;this.cdr.markForCheck();}
  }
  openWallet(){void this.router.navigate(['/organisations',this.ownerId,'wallet']);}
  hasPendingChanges() {return this.dataSpaceForm.dirty && !this.membership && !this.isSubmitting;}
  ngOnDestroy(){this.viewDestroyed=true;this.destroyed.next();this.destroyed.complete();this.stopPolling.next();this.stopPolling.complete();}
}
